import React from 'react';

import Block from 'components/Block';
import Container from 'components/Container';
import MetaTitle from 'components/MetaTitle';
import Layout from 'containers/Layout';
import Main from 'containers/Main';
import NewsletterPush from 'containers/NewsletterPush';

const StaticPage: React.FCWithChildren = ({ children }) => {
  return (
    <>
      <MetaTitle>About</MetaTitle>
      <Layout>
        <Main paddingTop>
          <Container>{children}</Container>
        </Main>

        <Block padding="extra" background="darker">
          <Container>
            <NewsletterPush />
          </Container>
        </Block>
      </Layout>
    </>
  );
};

export default StaticPage;
